import UnderConstruction from '@/pages/dashboard/UnderConstruction';

export default function AssinaturasPage() {
  return (
    <UnderConstruction
      title="Assinaturas"
      description="Planos, assinaturas e renovações."
    />
  );
}

